import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCarousel } from '../../redux/thunks/carousel.js'


const Carousel = ({ type }) => {

    const dispatch = useDispatch()
    const carousel = useSelector(state => state.carousel.data)

    useEffect(() => {
        dispatch(fetchCarousel(type))
    }, [dispatch, type])

    return (<div className={`fl-rw carousel__container ` + (!!carousel.length ? `animation_${carousel.length}` : "")}>
        {
            !!carousel.length && carousel.map((c, i) => (
                <div className={`carousel__div`} key={c._id} style={{ backgroundImage: `url(${c.desktop_img})` }} >
                    <div className="fl-cl carousel__div__div ">
                        <h2>{c.title}</h2>
                    </div>
                </div>
            ))
        }
    </div>)
}

export default Carousel;

